import React from 'react';
import ColataShell from '../../components/colata/ColataShell';
import TabellaStorico from './components/TabellaStorico';

// /colata-storico — registro (append-only) dei movimenti di magazzino, con storno
const ColataStoricoPage = () => (
  <ColataShell indietroA="/colata-inventory">
    <TabellaStorico />
  </ColataShell>
);

export default ColataStoricoPage;
